import type { RecordKind } from '@contracts';

/** Console routes for records. API source paths need the scope header, so links always go through these views. */
export function recordPath(mspId: string, kind: RecordKind | string, id: string) {
  const section = kind === 'organization' ? 'customers' : kind === 'site' ? 'sites' : 'devices';
  return `/w/${mspId}/${section}/${id}`;
}
